import logo from 'assets/logo-reverse.svg';
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link className="flex items-center text-white" to="./">
      <img className="h-14 w-auto" src={logo} alt="Workflow" />
    </Link>
  );
};
